import { MEDIA_GROUP, MEDIA_TYPES } from "../../constants/commonConstants";
import { MediaObject } from "../../models/channel.model";
import { LanguageData } from "../../models/staticmenu.models";
import { ChannelSubmenuApiLocale } from "./channelSubmenu.types";

const getTitleFromFileName = (fileName: string): string => {
  const name =
    fileName
      .split("/")
      .pop()
      ?.replace(/\.[^.]+$/, "") ?? "";
  return name.replace(/-/g, " ");
};

const toMediaObject = (
  channelImage: ChannelSubmenuApiLocale["channel_image"],
  pointMapping?: ChannelSubmenuApiLocale["point_mapping"]
): MediaObject[] | undefined => {
  if (!channelImage?.file_name) {
    return undefined;
  }

  return [
    {
      media_id: channelImage.id ?? undefined,
      file_name: channelImage.file_name,
      media_type: MEDIA_TYPES.IMAGE,
      title: getTitleFromFileName(channelImage.file_name),
      type: MEDIA_GROUP.CHANNEL,
      point_media_id: pointMapping?.[0]?.point_media_id ?? undefined,
      thumbnail_url: null,
    },
  ];
};

export const mapChannelSubmenuLocale = (
  locale: ChannelSubmenuApiLocale
): LanguageData => {
  const result: LanguageData = {
    title: locale.title ?? "",
    text: locale.text ?? "",
  };

  if (locale.image?.[0]?.file_name) {
    result.image = locale.image;
  } else {
    const image = toMediaObject(locale.channel_image, locale.point_mapping);
    if (image) {
      result.image = image;
    }
  }

  if (locale.channel_image?.id) {
    result.channel_image = locale.channel_image.id;
  }

  if (locale.point_mapping !== undefined) {
    result.point_mapping = locale.point_mapping;
  }

  return result;
};

export const processChannelSubmenuResponse = (
  apiData: Record<string, ChannelSubmenuApiLocale>
): Record<string, LanguageData> => {
  return Object.keys(apiData).reduce(
    (acc, lang) => {
      acc[lang] = mapChannelSubmenuLocale(apiData[lang]);
      return acc;
    },
    {} as Record<string, LanguageData>
  );
};
